import { render, staticRenderFns } from "./FullPageStudentProfile.vue?vue&type=template&id=0793ebc3&"
import script from "./FullPageStudentProfile.vue?vue&type=script&lang=js&"
export * from "./FullPageStudentProfile.vue?vue&type=script&lang=js&"
import style0 from "./FullPageStudentProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports